module.exports = __webpack_public_path__ + "static/img/footer-pattern.42513fb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/medias/images/footer-pattern.jpg
// module id = ALzS
// module chunks = 1